// todo fm remove component
import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {deleteAccount, logout} from '../../Redux/actions/authAction';
import styled from "styled-components";

const Navbar = ({
                    auth: {isAuthenticated, loading},
                    logout,
                    deleteAccount,
                }) => {
    const authLinks = (
        <>
            <Link to='/messenger'>Messenger</Link>

            <a onClick={deleteAccount} href='/'>
                <span>DeleteAccount</span>
            </a>

            <a onClick={logout} href='/'>
                <i className='fas fa-sign-out-alt'/> <span>Logout</span>
            </a>
        </>
    );

    const guestLinks = (
        <>
            <Link to='/login'>Login</Link>
            <Link to='/register'>Register</Link>
        </>
    );

    return (
        <Container>
            <div>NAVBAR</div>
            <Link to='/'>Home</Link>
            {!loading && (
                <React.Fragment>
                    {isAuthenticated ? authLinks : guestLinks}
                </React.Fragment>
            )}
        </Container>
    );
};

Navbar.prototype = {
    logout: PropTypes.func.isRequired,
    deleteAccount: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {logout, deleteAccount})(Navbar);

const Container = styled.div`
  padding: 25px 25px;
  display: flex;
  flex-wrap: nowrap;
  gap: 50px;
  background-color: #aaa;
`;